import { Injectable } from '@angular/core';
import { TaxDisplayItem, TaxInputItem } from '@sb/library/data-models';

@Injectable({
    providedIn: 'root'
})
export class TaxManager {
    ConvertToTaxInputItem(value: TaxDisplayItem[]): TaxInputItem[] {

        return value ? value.map(taxDefinition => new TaxInputItem({
            TaxDefinitionID: taxDefinition.TaxDefinitionID,
            RateOverride: taxDefinition.Rate
        })) : [];
    }

    ConvertToTaxDisplayItem(value: TaxInputItem[]): TaxDisplayItem[] {
        return value ? value.map(t => new TaxDisplayItem({
            TaxDefinitionID: t.TaxDefinitionID,
            Rate: t.RateOverride!
        })) : [];
    }
}
